// ----------------------------------------------------------------------
// <copyright file="Izenda.WorkspaceDashboardDetail.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var { map } = require('lodash/fp');
  var DashboardTile = require('./Dashboard/Izenda.DashboardTile');

  function WorkspaceDashboardDetail(data) {
    var props = {
      commonFilterFields: [],
      accesses: [],
      subscriptions: [],
      dashboardParts: [],
      name: '',
      description: null,
      categoryId: null,
      categoryName: null,
      subCategoryId: null,
      subCategoryName: null,
      tenantId: null,
      backgroundColor: '',
      imageUrl: null,
      stretchImage: false,
      id: null,
      state: 0,
      inserted: false,
      version: null,
      created: null,
      createdBy: null,
      createdById: null,
      modified: null,
      modifiedBy: null,
      showFilterDescription: true,
      ownerId: '',
      lastViewed: null,
      accessPriority: 1,
      checked: false
    };

    m.extendObservable(this, props);
    data && this.populateData(data);
  }

  /**
   * Populate data
   * @param  {Object} dashboard detail object
   */
  WorkspaceDashboardDetail.prototype.populateData = m.action(function(data) {
    data = data || {};

    var newParts = map(function(item) {
      return new DashboardTile(item);
    }, data.dashboardParts);

    this.commonFilterFields = data.commonFilterFields;
    this.accesses = data.accesses;
    this.subscriptions = data.subscriptions;
    this.dashboardParts.replace(newParts);

    this.commonFilterFields = data.commonFilterFields;
    this.name = data.name;
    this.description = data.description;
    this.categoryId = data.categoryId;
    this.categoryName = data.categoryName;
    this.subCategoryId = data.subCategoryId;
    this.subCategoryName = data.subCategoryName;
    this.tenantId = data.tenantId;
    this.backgroundColor = data.backgroundColor;
    this.imageUrl = data.imageUrl;
    this.stretchImage = data.stretchImage;
    this.id = data.id;
    this.state = data.state;
    this.inserted = data.inserted;
    this.version = data.version;
    this.created = data.created;
    this.createdBy = data.createdBy;
    this.createdById = data.createdById;
    this.modified = data.modified;
    this.modifiedBy = data.modifiedBy;
    this.showFilterDescription = data.showFilterDescription;
    this.ownerId = data.ownerId;
    this.accessPriority = data.accessPriority;
    this.lastViewed = data.lastViewed;
    this.checked = data.checked;
  });

  module.exports = WorkspaceDashboardDetail;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Izenda.WorkspaceDashboardDetail.js